import { IPortin } from "../ICart";

export interface IPortinPayload {
    accountNumber: string | undefined;
    type: string;
    portStartDateTime: string;
    msisdn: string;
}

export const getStateToPayload = (state: IPortin): IPortinPayload => ({
    accountNumber: state.otherNetworkAccountNumber,
    msisdn: state.phoneNumber,
    portStartDateTime: state.portStartDateTime,
    type: state.type,
});
